import { Select } from "antd";
import { useCascadeSelectOptions } from "components/UI/Selects/CascadeSelectSearchable/useCascadeSelectOptions.ts";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

type CascadeSelectSearchableProps = SearchableSelectWrapperProps & {
    offerId?: string;
};

export const CascadeSelectSearchable = ({ offerId, ...props }: CascadeSelectSearchableProps) => {
    const hookResult = useCascadeSelectOptions({ offerId });

    if (hookResult.loading && !hookResult.options.length) {
        return <Select {...props} loading disabled size={props.size ?? "middle"} />;
    }

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.channel"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
